export interface Market {
  value: string;
  label: string;
  symbol: string;
}

export const MARKETS: Market[] = [
  { value: 'BTC-EUR', label: 'Bitcoin (BTC)', symbol: 'BTC' },
  { value: 'ETH-EUR', label: 'Ethereum (ETH)', symbol: 'ETH' },
  { value: 'XRP-EUR', label: 'Ripple (XRP)', symbol: 'XRP' },
  { value: 'SOL-EUR', label: 'Solana (SOL)', symbol: 'SOL' },
  { value: 'ADA-EUR', label: 'Cardano (ADA)', symbol: 'ADA' },
  { value: 'DOT-EUR', label: 'Polkadot (DOT)', symbol: 'DOT' },
  { value: 'LINK-EUR', label: 'Chainlink (LINK)', symbol: 'LINK' },
  { value: 'LTC-EUR', label: 'Litecoin (LTC)', symbol: 'LTC' },
  { value: 'AVAX-EUR', label: 'Avalanche (AVAX)', symbol: 'AVAX' },
  { value: 'DOGE-EUR', label: 'Dogecoin (DOGE)', symbol: 'DOGE' },
  { value: 'MATIC-EUR', label: 'Polygon (MATIC)', symbol: 'MATIC' },
  { value: 'SHIB-EUR', label: 'Shiba Inu (SHIB)', symbol: 'SHIB' },
];

/** Flat list of market pair strings, e.g. ['BTC-EUR', 'ETH-EUR', ...] */
export const MARKET_IDS: string[] = MARKETS.map((m) => m.value);

export const DEFAULT_MARKET = 'BTC-EUR';
